import IDestination from 'interfaces/IDestination';
import RestService from './RestService';

export default class DestinationService extends RestService<IDestination> {
  constructor() {
    super('destinations');
  }
}
